import { useEffect } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { putContactAction } from 'src/redux/actions/contactActions';
import LoadingButton from 'src/components/UI/LoadingButton';
import { FORM, FORM_STATUS } from 'src/constants/Form';

const DeleteContactRelationDialog = () => {
  const dispatch = useAppDispatch();

  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.deleteContactrelation]) {
        return state.dialog[DIALOGS.deleteContactrelation];
      }
      return { opened: false, payload: null };
    });

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const putStatus = useSelector((state: Store) => state.formStatus[FORM.put_contact]);
  const processing = putStatus === FORM_STATUS.processing;

  useEffect(() => {
    if (putStatus === FORM_STATUS.success || putStatus === FORM_STATUS.error) {
      dispatch(closeDialog({ dialog: DIALOGS.deleteContactrelation }));
    }
  }, [putStatus]);

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteContactrelation }));
  };

  const handleOk = () => {
    dispatch(putContactAction(payload.contact.id, payload));
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="deleting-contact-relation"
      open={opened}>
      <DialogTitle id="deleting-contact-relation">{t(lang, 'menus.deleting_contact_relation')}</DialogTitle>
      <DialogContent dividers>
        {t(lang, 'menus.deleting_contact_relation')}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary" disabled={processing}>
          {t(lang, 'misc.no')}
        </Button>
        <LoadingButton onClick={handleOk} color="primary" loading={processing}>
          {t(lang, 'misc.yes')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteContactRelationDialog;
